import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoCadastroCfopDto,
  TributacaoCadastroDto,
  TributacaoCadastroSchema,
} from "./TributacaoCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import {
  TributacaoAtualizar,
  TributacaoBuscarPorId,
  TributacaoExcluir,
  TributacaoIncluir,
} from "src/services/Fiscal.Service";
import { showToast } from "src/componentes";
import { showMessageBox } from "src/componentes/MessageBox/Messagebox";

const TributacaoCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const [data, setData] = useState<TributacaoCadastroCfopDto[] | undefined>([]);

  const form = useForm<TributacaoCadastroDto>({
    resolver: yupResolver(TributacaoCadastroSchema),
    defaultValues: {
      padraoEmissaoCupomFiscal: false,
      padraoEmissaoCTe: false,
    },
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoBuscarPorId(id);
          if (response.data.success) {
            const data = response.data.data;
            form.reset(data);
            setIncluir(false);
            setData(data.cfop);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar Tributacao",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.tipoOperacao = Number(data.tipoOperacao);
    if (incluir) {
      TributacaoIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/fiscal/tributacao");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      TributacaoAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate("/fiscal/tributacao");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError
            );
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onExcluir = () => {
    if (!id) return;
    showMessageBox(
      "Deseja realmente excluir a tributação?",
      "Atenção!",
      "YesNo",
      "Warning",
      {
        onYes: handleExcluirConfirmado,
      }
    );
  };

  const handleExcluirConfirmado = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await TributacaoExcluir(Number(id));
      if (response.data.success) {
        showToast({
          message: "Tributação excluída com sucesso.",
          title: "Sucesso",
          variant: "Success",
        });
        navigate("/fiscal/tributacao");
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao excluir a tributação.",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    onSubmit,
    form,
    incluir,
    data,
    onExcluir,
    id,
  };
};
export default TributacaoCadastroCode;
